export enum SelectorPosition {
    TOP = "top",
    BOTTOM = "bottom",
}
